/**
 * Place for text related functions
 */

export const isEmptyString = (text: string | number | undefined): Boolean => {
  if (!text || text === "") return true
  return false
}
